import { Component }                from 'react';
import ReactDOM                     from 'react-dom';

class Portal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            container: null
        }
    }

    componentDidUpdate(prevProps, prevState) {
        let s = this.state;
        let p = this.props;
        if (s.container && prevProps.zIndex !== p.zIndex) {
            const newContainer = this.createContainer(p.zIndex);

            this.portalParent().replaceChild(s.container, newContainer);
            this.setState({ container: newContainer });
        } else if (!prevState.container && s.container) {
            this.portalParent().appendChild(s.container);
        }
    }

    componentDidMount() {
        let s = this.state;
        let p = this.props;
        if (s.container) {
            this.portalParent().appendChild(s.container);
        } else {
            const newContainer = this.createContainer(p.zIndex);
            this.setState({ container: newContainer });
        }
    }

    componentWillUnmount() {
        let p   = this.props;
        let s   = this.state;
        if (s.container) {
            const portals = !!document.querySelector(
                `body > .application-portal-container > .${p.portalClassName || 'application-portal'}`,
            );
            if (!portals) {
                document.body.removeChild(this.portalParent());
            }
        }
    }

    createContainer(zIndex) {
        let p = this.props;
        const container = document.createElement('div');
        container.setAttribute('class', p.portalClassName || 'application-portal');
        container.setAttribute('style', `z-index: ${zIndex}`);
        return container;
    }

    portalParent() {
        const parentElement = document.querySelector(
            'body > .application-portal-container',
        );
        if (!parentElement) {
            const parent = document.createElement('div');
            parent.setAttribute('class', 'application-portal-container');
            parent.setAttribute('style', `display: flex;`);
            document.body.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    
    render() {
        const s = this.state;
        return (
            s.container
                ? ReactDOM.createPortal(this.props.children, s.container)
                : this.props.children
        );
    }
}

export default Portal;